export function isCase(entry) {
    return 'caseType' in entry;
}
export function isProcedure(entry) {
    return 'procedureKey' in entry;
}
export function isCommunication(entry) {
    return 'category' in entry;
}
export function isEdtEntry(entry) {
    return 'activity' in entry;
}
export function isAnaestheticCase(entry) {
    return 'setting' in entry;
}
//# sourceMappingURL=types.js.map